import { render, staticRenderFns } from "./CardRiwayat.vue?vue&type=template&id=8e039414&scoped=true"
import script from "./CardRiwayat.vue?vue&type=script&lang=js"
export * from "./CardRiwayat.vue?vue&type=script&lang=js"
import style0 from "./CardRiwayat.vue?vue&type=style&index=0&id=8e039414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e039414",
  null
  
)

export default component.exports